module.exports = __webpack_public_path__ + "assets/img/profile-goals-active.06806676.svg";